let hideForCurrentRoute = false;
let isWidgetReady = false;

function applyVisibility() {
  if (!window.Tawk_API) return;

  if (hideForCurrentRoute) {
    window.Tawk_API.hideWidget?.();
  } else {
    window.Tawk_API.showWidget?.();
  }
}

/**
 * Shows/hides the Tawk.to widget. Safe to call before the Tawk script has
 * finished loading - the visibility is (re)applied once the widget is ready.
 */
export function setTawkWidgetHidden(hidden) {
  hideForCurrentRoute = hidden;
  if (isWidgetReady) {
    applyVisibility();
  }
}

/**
 * Called from Tawk_API.onLoad once the widget script has initialized, since
 * hideWidget/showWidget don't exist on Tawk_API until then.
 */
export function markTawkWidgetReady() {
  isWidgetReady = true;
  applyVisibility();
}
